// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"O2-z"};